// import VueRouter from "vue-router";
// // router setup
// import routes from "./routes";
// // configure router

// let instance = null;
// export const appRouter = () => {
//     if (instance === null) {
//         instance = new VueRouter({
//             routes,
//             linkActiveClass: "active",
//             mode: "history",
//             scrollBehavior(to, from, savedPosition) {
//                 return {
//                     x: 0,
//                     y: 0
//                 };
//             }
//         });
//         return instance;
//     }

//     return instance;
// };

import VueRouter from "vue-router";
import axios from "axios";
import routes from "./routes";
import { URL } from "../env";
import { NEVER_SWITCH, isV2Path, toV2Path } from "./v2/router/uiVersion";

const router = new VueRouter({
    routes,
    linkActiveClass: "active",
    mode: "history",
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        };
    }
});

router.beforeEach((to, from, next) => {
    if (!NEVER_SWITCH.includes(to.path) && !isV2Path(to.path)) {
        return next({ path: toV2Path(to.path), query: to.query, replace: true })
    }
    if(to.path == '/reset_password_view'){
        next();
        return;
    }
    let user_id = localStorage.getItem('user_id')
    let token = localStorage.getItem('access_token')
    if (to.name == 'Fcs' || to.name == 'V2Fcs') {
        localStorage.setItem('fcs_path', to.path)
    }
    else if (to.name == 'Plaid') {
        // localStorage.setItem('fcs_path', to.path)
    }



    if (!(to.path == '/login' || to.path == '/plaid' || to.path == '/v2/plaid') && !(token && (user_id && user_id != '0'))){
        next({path: '/login'});
    }
    else if (to.path == '/'){
        next({path: '/login'});
    }
    else if (to.name == 'SuperSyndicate' || to.name == 'V2SuperSyndicate'){
        // Permission-gated: only syndication managers may open this page.
        guardSuperSyndicate(user_id, next);
    }
    else{
        next();
    }

});

function guardSuperSyndicate(user_id, next){
    if(!user_id){
        next({path: '/login'});
        return;
    }
    axios.get(`${URL}/api/user_permission/user_permissions/${user_id}`)
        .then(res => {
            const perm = res.data.length > 0 ? res.data[0] : {};
            if(perm.syndcation_manager){
                next();
            } else {
                next({path: '/dashboard'});
            }
        })
        .catch(() => next({path: '/dashboard'}));
}

export default router


